import styled from "@emotion/styled";
import {formataDataTempoLong} from "./dataUtil";

export function getTitulo(ocorrencia) {
    return ocorrencia?.eventoAtual ? `${ocorrencia.eventoAtual}` : "Gerando ocorrência...";
}

export function getResumo(ocorrencia) {
    let resumo;

    resumo = (<>
        <D k="Id" v={ocorrencia.id}/>
        <D k="Contexto" v={ocorrencia.contexto}/>
        <D k="Modo" v={ocorrencia.modoEnvio}/>
        <D k="Estratégia" v={ocorrencia.estrategiaEnvio}/>
        <D k="Esfinge" v={ocorrencia.esfingeVersion}/>
    </>);

    return resumo;
}

const Element = styled("span")(() => ({
    whiteSpace: "nowrap"
}));
const Key = styled("span")(() => ({
    fontWeight: "500"
}));
const Value = styled("span")(() => ({
    marginLeft: 4, marginRight: 16, display: "inline-block"
}));

function D({k, v}) {
    return (<Element>
        <Key>{k}:</Key>
        <Value>{v || ""}</Value>
    </Element>);
}

export function getDataGeracao(data) {
    return data && `Gerado em ${formataDataTempoLong(data)}`;
}
